<template>
  <section class="company" v-if="company.id">
    <div class="main-sub-header">
      <div class="main-header-left">
        <h2 class="mobile-only">{{ company.name }}</h2>
        <h5>Company Type: {{ companyType }} <br/>
          <span v-if="company.phone">Phone: {{company.phone}} <br/></span>
          URL: <a v-bind:href="fullUrl">{{ company.url }}</a></h5>
      </div>
      <div class="main-header-right">
        <router-link class="button" :to="{name: 'companies.edit', params: {companyId: company.id}}" v-if="hasRole(['admin', 'subadmin', 'research_director', 'researcher'])">
          <span class="button-icon icon-edit"></span>
          Edit
        </router-link>
      </div>
    </div>
    <vue-tabs>
      <div class="tab" title="Company Locations">
        <div class="company-locations">
          <vue-table
              :columns="locationTable.columns"
              :column-titles="locationTable.columnTitles"
              :rows="company.locations"
              :total-rows="locationTable.totalRows">
            <div slot="empty">No locations</div>
          </vue-table>
        </div>
      </div>

      <div class="tab" title="People">
        <!--People – a list of all the people associated with that company and their contact info (name, title, e-mail, phone etc.)
            all contacts which reference this company -->
        <div class="company-contacts">
          <vue-table
              :columns="contactTable.columns"
              :column-titles="contactTable.columnTitles"
              :rows="company.contacts"
              :total-rows="contactTable.totalRows"
              v-on:selected-row="onSelectContactRow">
            <div slot="empty">No Associated Companies</div>
          </vue-table>
        </div>
      </div>

      <div class="tab" title="Projects">
        <div class="company-projects">
          <vue-table
              :columns="projectTable.columns"
              :rows="projects"
              :total-rows="projectTable.totalRows"
              v-on:selected-row="onSelectProjectRow">
            <div slot="empty">No Associated Projects</div>
          </vue-table>
        </div>
      </div>

      <div class="tab" title="Companies worked with">
        <div class="company-contacts">
          <vue-table
              :columns="partnerTable.columns"
              :rows="partners"
              :total-rows="partnerTable.totalRows"
              v-on:selected-row="onSelectCompanyRow">
            <div slot="empty">No Associated Companies</div>
          </vue-table>
        </div>
      </div>

      <div class="tab" title="Merge & fix" v-if="hasRole(['admin', 'subadmin', 'research_director'])">
        <p>The following companies have matching URLs as this one. Merging will remove associate its locations with this
          company and remove the other company.</p>
        <vue-table
            :columns="duplicatesTable.columns"
            :rows="duplicates"
            :total-rows="duplicatesTable.totalRows"
            v-on:selected-row="onSelectDuplicateRow">
          <div slot="empty">No duplicates found</div>
        </vue-table>
      </div>
    </vue-tabs>
  </section>
</template>

<script>

import VueTable from '../../Shared/VueTable.vue';
import ColumnView from '../../Shared/ColumnView.vue';
import VueButton from '../../Shared/VueButton.vue';
import VueModal from '../../Shared/VueModal.vue';
import VueTabs from '../../Shared/VueTabs.vue';
import StatusBlock from '../../Shared/StatusBlock.vue';
import WebServices from '../../../services/WebServices';
import Format from '../../../mixins/Format';
import {Marker, Map, gmapApi} from 'vue2-google-maps';


export default {

  mixins: [Format],
  components: {
    VueTable,
    VueButton,
    VueModal,
    StatusBlock,
    ColumnView,
    VueTabs,
    GoogleMap: Map,
    MapMarker: Marker,
  },

  data() {
    return {
      center: {lat: 10.0, lng: 10.0},
      companyServices: WebServices("Companies"),
      company: {
        id: 0,
        status: 0,
        stage: {},
        bidding_date: null,
        bidding_information: null,
        updates: [],
        locations: [],
      },
      projects: [],
      partners: [],
      duplicates: [],
      locationTable: {
        columns: {
          address1: {
            title: "Address 1"
          },
          address2: {
            title: "Address 2"
          },
          city: {
            title: "City"
          },
          state: {
            title: "State"
          },
          zip: {
            title: "Zip"
          },
          phone: {
            title: "Phone"
          },
        },
      },
      contactTable: {
        columns: {
          first_name: {
            title: "First Name"
          },
          last_name: {
            title: "Last Name"
          },
          title: {
            title: "Title"
          },
          email: {
            title: "Email"
          },
          phone: {
            title: "Phone"
          }
        },
        totalRows: 0
      },
      projectTable: {
        columns: {
          title: {
            title: "Name"
          },
          minimum_value: {
            title: "Value"
          },
          sector: {
            title: "Sector"
          },
          construction_type: {
            title: "Construction Type"
          },
          address1: {
            title: "Address"
          },
          city: {
            title: "City"
          },
          state: {
            title: "State"
          },
          zip: {
            title: "Zip"
          }
        }
      },
      partnerTable: {
        columns: {
          name: {
            title: "Company Name"
          },
          address1: {
            title: "Address 1"
          },
          address2: {
            title: "Address 2"
          },
          city: {
            title: "City"
          },
          state: {
            title: "State"
          },
          url: {
            title: "Url"
          }
        },
        totalRows: 0
      },

      duplicatesTable: {
        columns: {
          id: {
            title: "#",
          },
          name: {
            title: "Name"
          },
          types: {
            title: "Type",
            transform: function (value) {
              return value.map(item => item.name).join(", ");
            }
          },
          url: {
            title: "URL"
          },
          contacts_count: {
            title: "Contacts"
          },
          locations_count: {
            title: "Locations"
          }
        },
        totalRows: 0
      },
      request: {
        comment: ""
      },
    }
  },

  computed: {
    companyType() {
      if (this.company.types == null) return "";
      return this.company.types.map(function (item) {
        return item.name
      }).join(", ");
    },
    fullUrl() {
      if (!this.company.url || this.company.url.length === 0) return "#";
      if (this.company.url.indexOf("http") < 0) {
        return "http://" + this.company.url;
      } else {
        return this.company.url;
      }
    },
    google: gmapApi
  },

  created() {
    this.loadInitial();
  },

  methods: {
    loadInitial() {
      this.company.id = this.$route.params.companyId;
      this.get();
    },

    get() {

      this.companyServices
          .getOne(this.company.id)
          .then((response) => {

            this.company = response.data.data;
            this.company.partners = response.data.data.partners;

            this.companyServices.getCustom(`${this.company.id}/Projects`).then(response => {
              this.projects = response.data.data.map(record => record.project);
            })
            this.companyServices.getCustom(`${this.company.id}/Partners`).then(response => {
              this.partners = response.data.data;
            })

            if (this.hasRole(['admin', 'subadmin', 'research_director'])) {
              this.companyServices.getCustom(`${this.company.id}/Duplicates`).then(response => {
                this.duplicates = response.data.data;
              })
            }
          }, () => {
            swal({
              title: "Error",
              text: "A company with this ID could not be found. Please try searching for it instead.",
              type: "error",
              confirmButtonColor: "#40B572"
            }, function () {
              this.$router.push({name: "companies"});
              swal.close();
            }.bind(this));
          });
    },

    add() {

      this.companyServices
          .store({project_id: this.company.id}, "Save")
          .then(function () {
            this.get();
          }.bind(this));
    },

    remove() {

      this.companyServices
          .remove(this.company.id)
          .then(function () {
            this.get();
          }.bind(this));
    },

    onSelectContactRow(row) {
      this.$router.push({
        name: 'contacts.show',
        params: {
          contactId: row.id,
          company: {
            id: this.company.id,
            title: this.company.name,
          },
          row: row
        }
      });
    },

    onSelectProjectRow(row) {
      this.$router.push({name: 'projects.show', params: {projectId: row.id, row: row}});
    },

    onSelectDuplicateRow(row) {
      console.log(row)
      const otherCompany = `${row.name} (${row.url})`
      swal({
        title: "Merge Companies",
        text: `Are you sure you want to merge ${otherCompany} into this company?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes!",
        closeOnConfirm: true
      }, function () {
        this.companyServices.store({
          mergeWithId: row.id
        }, `${this.company.id}/Merge`)
            .then(() => this.get())
      }.bind(this));
    },

    onSelectCompanyRow(row) {
      this.$router.push({name: 'companies.show', params: {companyId: row.id, row: row}});
    },

    share() {

      var subject = this.company.title + " - Construct-A-Lead";
      var body = "";

      var a = document.createElement('a');

      a.href = 'mailto: ?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      a.setAttribute('style', 'display:none');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    print() {
      window.print();
    },
    hasRole(roles) {
      for (let i = 0; i < roles.length; ++i) {
        if (this.$root.$data.auth.hasRole(roles[i])) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    '$route.params.companyId': function () {
      this.loadInitial();
    },
  }
}


</script>
